var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Privacy.less');

module.exports = Section.extend({

    el: '.Privacy',

    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Privacy/Privacy.js
// module id = 290
// module chunks = 0